import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  doc,
  setDoc,
  collection,
  getDocs,
  deleteDoc,
  updateDoc,
  deleteField
} from 'firebase/firestore';
import { db } from '../../firebase/firebase';

/* inserts a schedule object (located in payload.data) to a schedule collection 
and returns both schedule name and object if succesfull */
export const createSchedule = createAsyncThunk(
  'calendarSchedules/createSchedule',
  async ({ uid, scheduleId, data }) => {
    try {
      await setDoc(doc(db, 'users', uid, 'schedules', scheduleId), data);
      return { uid, scheduleId, data };
    } catch (error) {
      return error;
    }
  }
);

export const updateSchedule = createAsyncThunk(
  'calendarSchedules/updateSchedule',
  async ({ uid, scheduleId, updatedData }) => {
    try {
      const scheduleRef = doc(db, 'users', uid, 'schedules', scheduleId);
      await updateDoc(scheduleRef, updatedData);
      return { uid, scheduleId, updatedData };
    } catch (error) {
      return error;
    }
  }
);

/* creates an object with the document name as a key and the list of contents 
as a value, checking if the content exists, returns a list of documents */
export const fetchSchedules = createAsyncThunk('calendarSchedules/fetchSchedules', async (uid) => {
  try {
    const documents = [];
    const snap = await getDocs(collection(db, 'users', uid, 'schedules'));
    snap.docs.map((doc) => {
      let content = [];
      let i = 0;
      while (doc.data()[i]) {
        content.push(doc.data()[i]);
        i++;
      }
      documents.push({ [doc.id]: content });
    });
    return documents;
  } catch (error) {
    return error;
  }
});

/* deletes a document in collection by a name of the document, returns deleted name
for a reducer */
export const removeSchedule = createAsyncThunk(
  'calendarSchedules/removeSchedule',
  async ({ uid, scheduleId }, { rejectWithValue }) => {
    try {
      const jobDocRef = doc(db, 'jobs', scheduleId);
      await updateDoc(jobDocRef, {
        scheduleSettings: deleteField(),
        price: deleteField(),
        projectPrice: deleteField(),
        hourlyRates: deleteField(),
        projectRates: deleteField(),
        extraProjects: deleteField(),
        recurrentPrices: deleteField(),
        rateType: deleteField()
      });

      return scheduleId;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  schedules: {},
  loading: false,
  error: null
};

export const calendarScheduleSlice = createSlice({
  name: 'calendarSchedules',
  initialState,
  reducers: {
    resetCalendarSchedule: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(createSchedule.fulfilled, (state, action) => {
        state.schedules[action.payload.scheduleId] = action.payload.data;
      })
      .addCase(fetchSchedules.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSchedules.fulfilled, (state, action) => {
        // Clear existing schedules
        state.schedules = {};
        action.payload.forEach((schedule) => {
          const scheduleId = Object.keys(schedule)[0];
          state.schedules[scheduleId] = schedule[scheduleId];
        });
        state.loading = false;
      })
      .addCase(fetchSchedules.rejected, (state) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(removeSchedule.fulfilled, (state, action) => {
        delete state.schedules[action.payload];
      })
      .addCase(removeSchedule.rejected, (state, action) => {
        state.error = action.error.message; // Handle errors
      });
  }
});

export const { resetCalendarSchedule } = calendarScheduleSlice.actions;
export default calendarScheduleSlice.reducer;
